import { useSignedInAccount } from '../../contexts/AccountContext';
import { useSkinPlan } from '../../hooks/useSkinPlan';
import { weeksSince } from '../../utils/account';
import { greeting } from '../../core/format/text';
import { accountTitle } from '../../ui/sections';
import { SkinPlanCard } from './cards/SkinPlanCard';
import { SeasonBanner } from './cards/SeasonBanner';
import { HomeCareCard } from './cards/HomeCareCard';
import { NextStepPanel } from './cards/NextStepPanel';
import { OverviewLinks } from './cards/OverviewLinks';

/**
 * Overzicht — het hoofdscherm. Bovenaan precies één volgende stap (cards/NextStepPanel, regel in
 * nextStep.ts); daaronder de routine (of, zonder thuisproducten, het protocol dat bij haar
 * behandeling hoort) en een rustige lijst naar Salon, Thuis en het dagboek.
 */
export function SkinJourney() {
  const {
    account
  } = useSignedInAccount();
  const {
    items,
    provisional,
    routine
  } = useSkinPlan();
  const hasPlan = items.length > 0;
  const week = hasPlan && !provisional ? `Week ${weeksSince(account.plan.startedOn) + 1} van je ${routine?.name ?? 'huidplan'}.` : '';
  return <div data-id="element-6611" data-mp="1qmwvfiks7jhl">
      <header className="mb-6 sm:mb-8" data-id="element-6612" data-mp="1qn5c7lk0z8y2">
        <h1 className={accountTitle} data-id="element-6613" data-mp="1qo82psdfr9dg">
          {greeting()}, <span className="italic text-clay" data-id="element-6614" data-mp="24meq2ekrdqyv">{account.customer.firstName}.</span>
        </h1>
        {week && <p className="mt-3 max-w-xl text-[16px] leading-relaxed text-muted" data-id="element-6615" data-mp="1zmsavzlde0nf">{week}</p>}
      </header>

      <NextStepPanel data-id="element-6616" data-mp="2ejj6dxrxas7r" />

      {hasPlan && <div className="mt-6" data-id="element-6617" data-mp="2ei7ypmvcx0bd">
          <SeasonBanner data-id="element-6618" data-mp="29lhnbcuhyswa" />
        </div>}

      <div className="mt-10 grid grid-cols-1 gap-10 xl:grid-cols-12 xl:gap-8" data-id="element-6619" data-mp="29kpyckventez">
        <div className="min-w-0 xl:col-span-7" data-id="element-6620" data-mp="2nbl3pn6p3sdt">{hasPlan ? <SkinPlanCard data-id="element-6621" data-mp="2neh21cmggj2s" /> : <HomeCareCard data-id="element-6622" data-mp="2jbaxqaiwl1yy" />}</div>
        <div className="min-w-0 xl:col-span-5" data-id="element-6623" data-mp="2jc3xgrjg2r7l">
          <OverviewLinks data-id="element-6624" data-mp="2jdf02o15lsx4" />
        </div>
      </div>
    </div>;
}